<template>
  <div class="marker-map">
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="30" viewBox="0 0 26 34" fill="none">
      <path
        d="M11.4397 33.3203C1.79068 19.3263 0 17.8912 0 12.7501C0 5.7078 5.7078 0 12.7501 0C19.7924 0 25.5002 5.7078 25.5002 12.7501C25.5002 17.8912 23.7096 19.3235 14.0605 33.3146C13.914 33.5257 13.7187 33.6982 13.4911 33.8175C13.2636 33.9368 13.0106 33.9994 12.7537 34C12.4968 34.0006 12.2436 33.939 12.0155 33.8207C11.7875 33.7024 11.5914 33.5307 11.4439 33.3203L11.4411 33.3146L11.4397 33.3203ZM12.7501 18.0627C14.1591 18.0627 15.5104 17.503 16.5067 16.5067C17.503 15.5104 18.0627 14.1591 18.0627 12.7501C18.0627 11.3411 17.503 9.98987 16.5067 8.99358C15.5104 7.99728 14.1591 7.43757 12.7501 7.43757C11.3411 7.43757 9.98987 7.99728 8.99358 8.99358C7.99728 9.98987 7.43757 11.3411 7.43757 12.7501C7.43757 14.1591 7.99728 15.5104 8.99358 16.5067C9.98987 17.503 11.3411 18.0627 12.7501 18.0627Z"
        :fill="fill"
      />
      <circle cx="12.5" cy="12.5" :r="lgeActive ? '8' : '6'" fill="white" />
      <text v-if="lgeActive" class="marker-map__icon backoffice-icons" x="12.5" y="18" fill="#000" text-anchor="middle">
        delivery
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'MarkerMapIntention',
  props: {
    filters: {
      type: Array,
      required: true,
    },
    lgeActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    source: {
      type: String,
      required: true,
    },
  },
  computed: {
    fill() {
      return this.filters.find(filter => filter.key === this.source)?.color || ''
    },
  },
}
</script>

<style lang="scss" scoped>
.marker-map {
  display: inline-flex;
  &__svg {
    width: 100%;
    height: 100%;
  }
  &__icon {
    font-size: 15px;
  }
}
</style>
